import { render, staticRenderFns } from "./sale-form.vue?vue&type=template&id=62d39d1a"
import script from "./sale-form.vue?vue&type=script&lang=ts"
export * from "./sale-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports